const validatePassword = (password: string) => {
  return password.length > 5;
};

export default validatePassword;
